module.exports = __webpack_public_path__ + "img/gys_30@2x.b76bab0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_30@2x.png
// module id = JFPd
// module chunks = 0